import { lazy, Suspense, useEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { Header } from '@/components/layout/Header'
import { Footer } from '@/components/layout/Footer'
import { CalculatorPage } from '@/pages/CalculatorPage'

const BlogListPage = lazy(() => import('@/pages/blog/BlogListPage'))
const BlogArticlePage = lazy(() => import('@/pages/blog/BlogArticlePage'))
const AboutPage = lazy(() => import('@/pages/AboutPage'))
const EmbedPage = lazy(() => import('@/pages/EmbedPage'))
const EmbedLandingPage = lazy(() => import('@/pages/EmbedLandingPage'))
const EmbedTestPage = lazy(() => import('@/pages/EmbedTestPage'))

function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (hash) {
      // Small delay to let the page render before scrolling to anchor
      setTimeout(() => {
        const el = document.querySelector(hash)
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100)
    } else {
      window.scrollTo(0, 0)
    }
    // Track page view in Google Analytics
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', { page_path: pathname })
    }
  }, [pathname, hash])
  return null
}

function AppContent() {
  const { pathname } = useLocation()
  // Only the bare `/embed` route is chrome-less. Other widget-related routes
  // like `/widget-hipoteczny/kreator` get the standard site header + footer.
  const isEmbed = pathname === '/embed'

  if (isEmbed) {
    return (
      <Suspense fallback={<div className="min-h-screen bg-muted/30 animate-pulse" />}>
        <Routes>
          <Route path="/embed" element={<EmbedPage />} />
        </Routes>
      </Suspense>
    )
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Suspense fallback={<div className="max-w-6xl mx-auto px-4 py-8"><div className="h-96 rounded-2xl bg-muted/50 animate-pulse" /></div>}>
          <Routes>
            <Route path="/" element={<CalculatorPage />} />
            <Route path="/o-kalkulatorze" element={<AboutPage />} />
            <Route path="/widget-hipoteczny" element={<EmbedLandingPage />} />
            <Route path="/widget-hipoteczny/kreator" element={<EmbedTestPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogArticlePage />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppContent />
    </BrowserRouter>
  )
}

export default App
